/**
 * Mock integrations data for standalone mode
 * Used when APIs are not available in standalone environment
 */

export const mockIntegrationsData = {
  integrations: [
    {
      id: 1,
      displayName: "My AWS Integration",
      integrationType: "AWS",
      isPrivateApp: false,
      isEnabled: true,
      connectionStatus: "VALID",
      features: [
        {
          featureName: "POSTURE_FOR_AI",
          metadata: {
            type: "security_posture",
            category: "ai_governance",
            templateIds: [
              "aws-bedrock-agent",
              "aws-bedrock-model",
              "aws-iam-inline-policy",
              "aws-iam-role",
              "aws-bedrock-guardrail",
              "aws-iam-policy-documents",
              "aws-bedrock-knowledge-base",
              "aws-iam-user",
            ],
          },
          featureConfig: {
            regions: ["us-east-1"],
          },
          schedules: [
            {
              scheduleName: "weekly User Sync",
              cronExpression: "0 */2 * * *",
              metadata: {
                timezone: "UTC",
                description: "Weekly provisioning check TEST",
              },
              createdDate: 1766119919433,
              updatedDate: 1766119919433,
            },
          ],
        },
      ],
      createdDate: 1765474241354,
      updatedDate: 1765474241354,
      metadata: {
        accountId: "123456789012",
        environment: "dev",
      },
    },
    {
      id: 3,
      displayName: "AWS IAM Identity Center SCIM Implementation",
      integrationType: "AWS",
      isPrivateApp: false,
      isEnabled: true,
      connectionStatus: "INVALID",
      features: [
        {
          featureName: "USER_SYNC",
          metadata: {
            type: "user_management",
            category: "sync",
          },
          featureConfig: {
            regions: ["us-east-1"],
          },
          schedules: [],
        },
      ],
      createdDate: 1765532030454,
      updatedDate: 1765532030454,
      metadata: {},
    },
    {
      id: 6,
      displayName: "CERT_CREDS",
      integrationType: "AWS",
      isPrivateApp: false,
      isEnabled: true,
      connectionStatus: "INVALID",
      features: [
        {
          featureName: "USER_SYNC",
          metadata: {
            type: "user_management",
            category: "sync",
          },
          featureConfig: {
            regions: ["us-east-1"],
          },
          schedules: [],
        },
      ],
      createdDate: 1765960690343,
      updatedDate: 1765960690343,
      metadata: {
        region: "us-east-1",
        accountId: "123456789012",
        description: "Production AWS integration",
      },
    },
    {
      id: 7,
      displayName: "Laxman",
      integrationType: "AWS",
      isPrivateApp: false,
      isEnabled: true,
      connectionStatus: "UNKNOWN",
      features: [
        {
          featureName: "USER_SYNC",
          metadata: {
            type: "user_management",
            category: "sync",
          },
          featureConfig: {
            regions: ["us-east-1"],
          },
          schedules: [],
        },
      ],
      createdDate: 1765961620556,
      updatedDate: 1765961620556,
      metadata: {
        region: "us-east-1",
        accountId: "123456789012",
        description: "Production AWS integration",
      },
    },
    {
      id: 9,
      displayName: "AWS-869935070807-Working",
      integrationType: "AWS",
      isPrivateApp: false,
      isEnabled: true,
      connectionStatus: "INVALID",
      features: [
        {
          featureName: "POSTURE_FOR_AI",
          metadata: {
            type: "security_posture",
            category: "ai_governance",
            templateIds: [
              "aws-bedrock-agent",
              "aws-bedrock-model",
              "aws-iam-inline-policy",
              "aws-iam-role",
              "aws-bedrock-guardrail",
              "aws-iam-policy-documents",
              "aws-bedrock-knowledge-base",
              "aws-iam-user",
            ],
          },
          featureConfig: null,
          schedules: [],
        },
      ],
      createdDate: 1766395355895,
      updatedDate: 1766395355895,
      metadata: {
        region: "us-east-1",
        accountId: "869935070807",
        description: "Production AWS integration",
      },
    },
    {
      id: 10,
      displayName: "AWS-869935070807-Working",
      integrationType: "AWS",
      isPrivateApp: false,
      isEnabled: true,
      connectionStatus: "INVALID",
      features: [
        {
          featureName: "POSTURE_FOR_AI",
          metadata: {
            type: "security_posture",
            category: "ai_governance",
            templateIds: [
              "aws-bedrock-agent",
              "aws-bedrock-model",
              "aws-iam-inline-policy",
              "aws-iam-role",
              "aws-bedrock-guardrail",
              "aws-iam-policy-documents",
              "aws-bedrock-knowledge-base",
              "aws-iam-user",
            ],
          },
          featureConfig: null,
          schedules: [],
        },
      ],
      createdDate: 1766396966935,
      updatedDate: 1766396966935,
      metadata: {
        region: "us-east-1",
        accountId: "869935070807",
        description: "Production AWS integration",
      },
    },
  ],
};
